class Layer {
  constructor(api) {
    this.api = api;
  }

  getAll(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/layers")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAsMenu(filters, onSuccess, onError) {
    let filter = "";
    if (filters) {
      filter = "?filter=" + filters;
    }
    return this.api.http_fibercloud
      .get("v1/layers/menu" + filter)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default Layer;



// WEBPACK FOOTER //
// ./src/api/layer.js